import { render } from "./AdsOverview.vue?vue&type=template&id=3b648d95&ts=true"
import script from "./AdsOverview.vue?vue&type=script&lang=ts"
export * from "./AdsOverview.vue?vue&type=script&lang=ts"

import "./AdsOverview.vue?vue&type=style&index=0&id=3b648d95&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__